import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    completePlanDeveloppementStepRequest,
    fetchPlanDeveloppementStepRequest,
    generatePlanDeveloppementRecommendationsRequest,
} from "../../../../redux/actions/performanceActions";
import { asArray, StepState } from "../performanceUi";
import "./PlanDeveloppementStep.css";

const staticPlanCards = [
    {
        title: "Leadership et Management",
        text: "Developpez vos pratiques de leadership, d'accompagnement et de pilotage d'equipe.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978",
        badge: "Formation",
    },
    {
        title: "Gestion de projet",
        text: "Structurez les priorites, les livrables et le suivi des actions avec une methode claire.",
        image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
        badge: "Formation",
    },
    {
        title: "Communication efficace",
        text: "Renforcez la qualite des echanges, la clarte des messages et la collaboration.",
        image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
        badge: "Formation",
    },
];

export default function PlanDeveloppementStep({ progressId }) {
    const dispatch = useDispatch();
    const slice = useSelector((state) => state.performance.planDeveloppement);
    const data = slice.stepByProgressId[String(progressId)];
    const loading = slice.loadingByProgressId[String(progressId)];
    const error = slice.errorByProgressId[String(progressId)];
    const recommendations = asArray(data?.recommendations);
    const items = asArray(data?.items);
    const hasFormationCampaign = data?.formationCampaignAssociated !== false;

    useEffect(() => {
        if (progressId) dispatch(fetchPlanDeveloppementStepRequest(progressId));
    }, [dispatch, progressId]);

    return (
        <StepState loading={loading} error={error} empty={!data}>
            <div className="plan-container">
                <h2 className="plan-title">Mon plan de developpement</h2>

                {!hasFormationCampaign ? (
                    <>
                        <h3 className="plan-section">Plan de developpement</h3>
                        <div className="plan-grid">
                            {staticPlanCards.map((card) => (
                                <div className="plan-card" key={card.title}>
                                    <div className="plan-card__image">
                                        <img src={card.image} alt="" />
                                        <span className="plan-badge">{card.badge}</span>
                                    </div>
                                    <div className="plan-card__content">
                                        <h4>{card.title}</h4>
                                        <p>{card.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        {data?.blockedReason && <div className="perf-state perf-state--warning">{data.blockedReason}</div>}
                        <div className="perf-actions perf-actions--top">
                            <button className="perf-btn" type="button" onClick={() => dispatch(generatePlanDeveloppementRecommendationsRequest(progressId))}>
                                Generer recommandations
                            </button>
                            <button className="perf-btn perf-btn--primary" type="button" onClick={() => dispatch(completePlanDeveloppementStepRequest(progressId))}>
                                Terminer l'etape
                            </button>
                        </div>

                        <h3 className="plan-section">Recommande pour vous</h3>
                        {recommendations.length === 0 && <div className="empty-state">Aucune recommandation.</div>}
                        <div className="plan-grid">
                            {recommendations.map((recommendation, index) => (
                                <div className="plan-card" key={recommendation.competenceNom || recommendation.skillNom || index}>
                                    <div className="plan-card__content">
                                        <h4>{recommendation.competenceNom || recommendation.skillNom || "Recommendation"}</h4>
                                        <span className="status IN_PROGRESS">Gap {recommendation.gap ?? "-"}</span>
                                        <p>{recommendation.reason || "Recommandation proposee par le backend."}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <h3 className="plan-section">Mon plan selectionne</h3>
                        {items.length === 0 && <div className="empty-state">Aucun element selectionne</div>}
                        <div className="plan-grid small">
                            {items.map((item) => (
                                <div className="plan-card small" key={item.id}>
                                    <div className="plan-card__content">
                                        <h4>{item.formationNom || item.competenceNom || item.skillNom || "Action de developpement"}</h4>
                                        <span className={`status ${item.status || "IN_PROGRESS"}`}>{item.status || "PLAN"}</span>
                                        <p>{item.recommendationReason || item.commentaire || "Action ajoutee au plan."}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </StepState>
    );
}
